import { gql } from "@apollo/client";

export const STAFF_EMAIL_FIELDS = gql`
  fragment StaffEmailFields on StaffEmail {
    email
    fullName
    createdAt
  }
`;

export const ADD_STAFF_EMAIL = gql`
  ${STAFF_EMAIL_FIELDS}
  mutation AddStaffEmail($input: AddStaffEmailInput!) {
    addStaffEmail(input: $input) {
      ...StaffEmailFields
    }
  }
`;

export const REMOVE_STAFF_EMAIL = gql`
  mutation RemoveStaffEmail($input: RemoveStaffEmailInput!) {
    removeStaffEmail(input: $input)
  }
`;

export const LIST_STAFF_EMAILS = gql`
  ${STAFF_EMAIL_FIELDS}
  query ListStaffEmails {
    listStaffEmails {
      ...StaffEmailFields
    }
  }
`;
